<template>
    <div v-if="bedrooms || bathrooms">
        <div v-if="bedrooms">
            <h4 class="mb-3">Where you'll sleep</h4>

            <container>
                <row>
                    <column :md="12" :lg="8" v-for="(bedroom, index) in bedrooms" :key="`property-${property.id}-bedroom-${bedroom.id}-${index}`" class="pb-4">
                        <bedroom :bedroom="bedroom" :property="property" :num="(index + 1)" class="h-100"/>
                    </column>
                </row>
            </container>
        </div>
        <hr class="my-5"/>
        <div v-if="bathrooms">
            <h4 class="mb-3">Bathroom Arrangments</h4>

            <container>
                <row>
                    <column :md="12" :lg="8" v-for="(bathroom, index) in bathrooms" :key="`property-${property.id}-bathroom-${bathroom.id}-${index}`" class="pb-4">
                        <bathroom :bathroom="bathroom" :property="property" :num="(index + 1)" class="h-100"/>
                    </column>
                </row>
            </container>
        </div>
        
    </div>
    <div v-else-if="!propertyWithRooms && !error" class="text-center p-5">
        <spinner size="lg"/>
    </div>
</template>

<script type="text/javascript">

    import Bedroom from '@/components/Content/Public/Properties/Rooms/Bedroom.vue';
    import Bathroom from '@/components/Content/Public/Properties/Rooms/Bathroom.vue';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import ApiConfig from '@/config/api.json';
    

    import { UseApiStore } from '@/store/Api.js';

    export default {
        components: {
            Bedroom,
            Bathroom,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
            };
        },

        data() {
            return {
                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,
            };
        },

        created() {
            this.requestData();
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {

            requestUrl() {
                let url = 'properties/'+this.property.id+'/rooms';
                return url;
            },
            
            propertyWithRooms() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    return response.results;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },
            
            bedrooms() {

                if (
                    (this.propertyWithRooms) &&
                    (this.propertyWithRooms.bedroomConfigurations) &&
                    (this.propertyWithRooms.bedroomConfigurations.length)
                ) {
                    return this.propertyWithRooms.bedroomConfigurations;
                }

                return null;
            },

            bathrooms() {
                if (
                    (this.propertyWithRooms) &&
                    (this.propertyWithRooms.bathroomConfigurations) &&
                    (this.propertyWithRooms.bathroomConfigurations.length)
                ) {
                    return this.propertyWithRooms.bathroomConfigurations;
                }

                return null;
            },
            
        },

        methods: {

            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get(this.requestUrl);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);
            },

            setError(error) {
                this.error = error;
            },
            
            setEmptyResults(val) {
                this.emptyResults = val;
            },
        }
    };

</script>
